import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 员工
 */
const employees = {

  /**
   * 添加员工
   */
  addEmployees (companyId, employees, loginPassword) {
    return axios.post(base.employees.addEmployees, utils.postParamsArrayToJsonString({ companyId, employees, loginPassword }))
  },
  /**
   * 查询员工
   */
  listEmployees (companyId) {
    return axios.post(base.employees.listEmployees, utils.postParamsArrayToJsonString({ companyId }))
  },
  /**
   * 查询员工
   */
  listEmployees2 (orgStructNodeId, onlyDirect) {
    return axios.post(base.employees.listEmployees2, utils.postParamsArrayToJsonString({ orgStructNodeId, onlyDirect }))
  },
  /**
   * 编辑员工
   */
  modifyEmployee (id, roleId, hireDate, employeeNumber, loginPassword) {
    return axios.post(base.employees.modifyEmployee, utils.postParamsArrayToJsonString({ id, roleId, hireDate, employeeNumber, loginPassword }))
  },
  /**
   * 删除员工
   */
  deleteEmployees (ids) {
    return axios.post(base.employees.deleteEmployees, utils.postParamsArrayToJsonString({ ids }))
  },
}

export default employees